"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var ReportsModel = /** @class */ (function () {
    function ReportsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/reports",
            UPDATE: APPURL + "/api/v1/reports",
            CREATE: APPURL + "/api/v1/reports",
        };
        this.report = [];
        this.extract = this.extract.bind(this);
        this.cacheResponse = this.cacheResponse.bind(this);
    }
    ReportsModel.prototype.extract = function (result) {
        return result.data;
    };
    ReportsModel.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    ReportsModel.prototype.getAdminStudentIndexStats = function (data) {
        if (data) {
            return this.$http
                .get(this.URLS.FETCH + "/adminStudentIndex?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResponse);
        }
        return this.$http
            .get(this.URLS.FETCH + "/adminStudentIndex")
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getAdminDashboard = function () {
        return this.$http
            .get(this.URLS.FETCH + "/admin/dashboard")
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getSchedulingDashboard = function (data) {
        return this.$http
            .get(this.URLS.FETCH + "/scheduling/dashboard?" + (0, queryString_1.toQueryString)(data))
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getZipBoundaries = function (zips) {
        return this.$http
            .get(this.URLS.FETCH +
            "/scheduling/zip-boundaries?" +
            (0, queryString_1.toQueryString)({ zips: zips.join(",") }))
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getEcommerceDashboard = function (data) {
        return this.$http
            .get(this.URLS.FETCH + "/ecommerce/dashboard?" + (0, queryString_1.toQueryString)(data))
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getFranchiseReport = function (data) {
        var school_ids = data.school_ids, filters = __rest(data, ["school_ids"]);
        var schoolIds = school_ids.length > 0 ? school_ids.join(",") : null;
        return this.$http
            .get(this.URLS.FETCH +
            "/franchise?" +
            (0, queryString_1.toQueryString)(__assign(__assign({}, filters), { school_ids: schoolIds })))
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getMarketingReport = function (data) {
        var school_ids = data.school_ids, filters = __rest(data, ["school_ids"]);
        var schoolIds = school_ids.length > 0 ? school_ids.join(",") : null;
        return this.$http
            .get(this.URLS.FETCH +
            "/marketing?" +
            (0, queryString_1.toQueryString)(__assign(__assign({}, filters), { school_ids: schoolIds })))
            .then(this.cacheResponse);
    };
    ReportsModel.prototype.getPickupLocations = function () {
        return this.$http
            .get(this.URLS.FETCH + "/pickuplocations")
            .then(this.cacheResponse);
    };
    return ReportsModel;
}());
ReportsModel.$inject = ["$http", "APPURL"];
exports.default = ReportsModel;
